
export class AllkeymeMail {
date: number | null;
files: string[];
from: string;
important: boolean;
recipients: string[];
subject: string;
sumamry: string;
text: string;
}

